import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function DataPerusahaan({ companyId }) {
  const [nama, setNama] = useState('');
  const [bentuk, setBentuk] = useState('PT');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    loadData();
  }, [companyId]);

  const loadData = async () => {
    try {
      const params = companyId ? { company_id: companyId } : {};
      const res = await axios.get(`${API}/api/company`, { params });
      setNama(res.data.nama_perusahaan || '');
      setBentuk(res.data.bentuk_badan || 'PT');
    } catch {}
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setMsg('');
    try {
      const params = companyId ? { company_id: companyId } : {};
      await axios.put(`${API}/api/company`, { nama_perusahaan: nama, bentuk_badan: bentuk }, { params });
      setMsg('Data berhasil disimpan!');
    } catch {
      setMsg('Gagal menyimpan data');
    } finally {
      setSaving(false);
    }
  };

  if (!companyId && companyId !== undefined) {
    return <div style={s.empty}>Pilih perusahaan terlebih dahulu dari menu "Semua Perusahaan"</div>;
  }

  return (
    <div style={s.wrap}>
      <h2 style={s.h2}>🏢 Data Perusahaan</h2>
      <div style={s.card}>
        <form onSubmit={handleSave}>
          <div style={s.field}>
            <label style={s.label}>Nama Perusahaan</label>
            <input style={s.input} value={nama} onChange={e => setNama(e.target.value)} placeholder="Nama lengkap perusahaan" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>Bentuk Badan</label>
            <select style={s.input} value={bentuk} onChange={e => setBentuk(e.target.value)}>
              <option>PT</option>
              <option>CV</option>
              <option>Yayasan</option>
              <option>Firma</option>
              <option>Koperasi</option>
              <option>Lainnya</option>
            </select>
          </div>
          {msg && <div style={{ ...s.msg, color: msg.includes('berhasil') ? '#16a34a' : '#dc2626' }}>{msg}</div>}
          <button type="submit" style={s.btn} disabled={saving}>{saving ? 'Menyimpan...' : 'Simpan Data'}</button>
        </form>
      </div>
    </div>
  );
}

const s = {
  wrap: { maxWidth: '600px' },
  h2: { fontSize: '20px', fontWeight: '700', color: '#1a1a2e', marginBottom: '20px' },
  card: { background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  field: { marginBottom: '16px' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '6px' },
  input: { width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  msg: { padding: '10px', background: '#f0fdf4', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' },
  btn: { padding: '10px 24px', background: '#1a1a2e', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  empty: { color: '#666', padding: '24px', background: 'white', borderRadius: '12px' }
};
